import $ from 'jquery';
import {SpeakerFactory} from "./speechSynthesis.es6";

const SOURCE_ATTRIBUTE = 'audio-source';
const SOURCE_AUDIO = 'audio';
const SOURCE_SPEECH = 'speech';

// const log = console.log;
const log = $.noop;

let RID = 0;
let STOPPERS = [];

function noop() {
}

function registerStopper(fn) {
    const rid = ++RID;
    return {
        enable: function () {
            STOPPERS[rid] = fn;
        },
        disable: function () {
            delete STOPPERS[rid];
        }
    }
}

SpeakerFactory.addReadyCallback(() => {
    log('got voices');
});

export default class CardSound {
    static addReadyCallback(fn) {
        SpeakerFactory.addReadyCallback(fn);
    }

    static stop() {
        SpeakerFactory.cancel();

        // stop all started audio
        Object.values(STOPPERS).forEach(fn => fn());
        STOPPERS = [];
    }

    static multiSideButton(buttonElement, ...sides) {
        const controller = new SoundButtonSequence(buttonElement);
        sides.forEach(side => controller.add(side));
        return controller;
    }

    static singleSideButton(buttonElement, side) {
        return new SoundButtonController(
            side,
            new SoundButtonState(buttonElement));
    }
}

class SoundButtonState {
    constructor(buttonElement) {
        this.button = $(buttonElement);
    }

    get playing() {
        return this.button.hasClass('text-success');
    }

    set playing(value) {
        this.button.toggleClass('text-success', value);
    }
}

class SoundButtonController {
    constructor(contentNode, stater) {
        this.stater = stater;
        this.node = $(contentNode);
        this._completer = noop;
    }

    _resolveSoundSource() {
        let source = this.node.data(SOURCE_ATTRIBUTE);
        if (!source) {
            const ret = (source) => {
                this.node.data(SOURCE_ATTRIBUTE, source);
                return source;
            };

            // if it's audio from audio tag
            const audioTag = this.node.find('audio');
            if (audioTag.length) {
                const audio = audioTag.get(0);
                const stopper = registerStopper(() => {
                    audio.pause();
                });

                audioTag
                    .on('pause', () => {
                        stopper.disable();
                        this._invokeCompleter();
                        this.stater.playing = false;
                    })
                    .on('play', () => {
                        stopper.enable();
                        this.stater.playing = true;
                    });
                return ret(SOURCE_AUDIO);
            }

            return ret(SOURCE_SPEECH);
        }

        return source;
    }

    _invokeCompleter() {
        if (this._completer) {
            this._completer();
            this._completer = null;
        }
    }

    _afterStop() {
    }

    _speechToggle() {
        if (this.stater.playing) {
            CardSound.stop();
        } else {
            this._speechStart();
        }
    }

    _speechStart() {
        const lang = this.node.data('lang');

        let text = this.node.data('text');
        if (!text) {
            text = this.node.text();
        }

        const speaker = SpeakerFactory.create(text, lang);
        if (speaker != null) {
            speaker.say(
                () => {
                    this.stater.playing = true;
                },
                () => {
                    this._invokeCompleter();
                    this.stater.playing = false;
                });
        }
    }

    _audioToggle() {
        const audio = this.node.find('audio').get(0);
        if (audio.paused) {
            this._audioStart();
        } else {
            audio.pause();
        }
    }

    _audioStart() {
        const audio = this.node.find('audio').get(0);
        audio.currentTime = 0;
        audio.play();
    }

    toggle(completer) {
        this._completer = completer || noop;

        const source = this._resolveSoundSource();
        switch (source) {
            case SOURCE_AUDIO:
                this._audioToggle();
                break;
            case SOURCE_SPEECH :
                this._speechToggle();
                break;
        }
    }

    start(completer) {
        this._completer = completer || noop;

        const source = this._resolveSoundSource();
        switch (source) {
            case SOURCE_AUDIO:
                this._audioStart();
                break;
            case SOURCE_SPEECH :
                this._speechStart();
                break;
        }
    }

    stop() {
        CardSound.stop();
    }
}

class SoundButtonSequence {
    constructor(buttonElement) {
        this.buttonElement = buttonElement;
        this._delegates = [];
        this._next = noop;
        this._current = null;

        this._stopper = registerStopper(() => this.stop());
    }

    get playing() {
        return $(this.buttonElement).hasClass('text-success');
    }

    set playing(value) {
        $(this.buttonElement).toggleClass('text-success', value);
        if (!value) {
            this._next();
        }
    }

    add(element) {
        if (!element) {
            return;
        }
        this._delegates.push(element);
    }

    toggle() {
        if (this.playing) {
            this.stop();
        } else {
            this.start();
        }
    }

    start() {
        if (this._delegates.length === 0) {
            return;
        }

        this._stopper.enable();
        this._next = () => {
            if (this._current == null) {
                return;
            }

            const next = this._current.index + 1;
            if (next < this._delegates.length) {
                this._goTo(next);
            } else {
                this.stop();
            }
        };
        this._goTo(0);
    }

    stop() {
        log('SoundButtonSequence: stop');

        this._next = noop;
        this._stopper.disable();

        if (this._current) {
            this._current.stop();
            this._current = null;
        }
    }

    _goTo(index) {
        log(`SoundButtonSequence: say ${index}...`);

        this._current = new SoundButtonController(this._delegates[index], this);
        this._current.index = index;
        this._current.start();
    }
}
